/* eslint-disable import/prefer-default-export */
import numeral from 'numeral';

/**
 * Apply a Numeral.js formatting string to an input number, based on its value
 *
 * @param {number} inputVal - input value to be formatted
 * @param {string} [givenFormat='0,0'] - Numeral.js format string
 * @returns {string} - formatted output string
 */
export function autoFormatNumber(inputVal, givenFormat = null) {
    const val = Math.abs(inputVal);
    let format = givenFormat;

    if (!givenFormat) {
        format = '0,0';
        if (val === 0) {
            format = '0';
        } else if (val < 1) {
            format = '0.000';
        } else if (val < 10) {
            format = '0.00';
        } else if (val < 100) {
            format = '0.0';
        }
    }

    return numeral(inputVal).format(format);
}
